import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type DatePickerState = {
  start_date: string | null;
  end_date: string | null;
  current_preset: string;
};

const initialState: DatePickerState = {
  start_date: null,
  end_date: null,
  current_preset: "this-month",
};

export const datePickerSlice = createSlice({
  name: "datepicker",
  initialState,
  reducers: {
    setPreset: (state, action: PayloadAction<string>) => {
      state.current_preset = action.payload;
    },
    setDateRange: (
      state,
      action: PayloadAction<{ from: string; to: string }>,
    ) => {
      state.start_date = action.payload.from;
      state.end_date = action.payload.to;
    },
  },
});

export const { setPreset, setDateRange } = datePickerSlice.actions;
export default datePickerSlice.reducer;
